import { render, staticRenderFns } from "./PeriodCalendar.vue?vue&type=template&id=567e6957&scoped=true"
import script from "./PeriodCalendar.vue?vue&type=script&lang=js"
export * from "./PeriodCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567e6957",
  null
  
)

export default component.exports